// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 593 ? "framework" : chunkId) + "-" + {"579":"451cb030d00436baafe4","593":"8e8f11f2ba6b371891cf","896":"c64829b9f00fc7f3ef31"}[chunkId] + ".js";
};